module.exports = __webpack_public_path__ + "static/media/img-teams.4e729a58.png";